{
  "common": {
    "ok": "OK",
    "cancel": "Abbrechen",
    "yes": "Ja",
    "no": "Nein",
    "loading": "Laden...",
    "error": "Fehler",
    "retry": "Erneut versuchen",
    "apply": "Anwenden",
    "add": "Hinzufügen"
  },
  "navigation": {
    "home": "Startseite",
    "favorites": "Favoriten",
    "search": "Suchen"
  },
  "jobs": {
    "noJobs": "Keine Jobs gefunden",
    "loadMore": "Mehr laden",
    "apply": "Bewerben",
    "save": "Speichern",
    "unsave": "Entfernen"
  },
  "search": {
    "placeholder": "Jobs suchen...",
    "filter": "Filtern",
    "clear": "Löschen",
    "open": "Jobs suchen",
    "close": "Suche schließen"
  },
  "alerts": {
    "title": "Job-Benachrichtigungen",
    "subtitle": "Erhalte eine Push-Nachricht, wenn neue passende Jobs erscheinen.",
    "placeholder": "Stichwörter (z. B. react remote senior)",
    "empty": "Noch keine Benachrichtigungen",
    "matchingNow": "{{count}} passen jetzt"
  },
  "description": {
    "openUrlMessage": "URL für weitere Informationen öffnen",
    "postedOn": "Veröffentlicht am",
    "applyViewDetails": "Bewerben / Details anzeigen"
  },
  "error": {
    "title": "Etwas ist schiefgelaufen",
    "description": "Entschuldigung, keine Jobs gefunden! Dies ist wahrscheinlich ein Server- oder Netzwerkfehler.",
    "tryAgain": "Erneut versuchen"
  },
  "filter": {
    "refineJobs": "Jobs verfeinern",
    "title": "Filter",
    "total": "insgesamt",
    "reset": "Zurücksetzen",
    "filterByDate": "Nach Datum filtern",
    "byDate": "Nach Datum",
    "byApplied": "Nach Bewerbungen",
    "appliedOnlyOn": "Nur Bewerbungen: an",
    "appliedOnlyOff": "Nur Bewerbungen: aus",
    "postedAfter": "Veröffentlicht nach",
    "filterByTags": "Nach Tags filtern",
    "byTag": "Nach Tag",
    "clearAllFavorites": "Alle Favoriten löschen",
    "applyFilters": "Filter anwenden"
  },
  "share": {
    "message": "Hier ist eine großartige Remote-Job-Möglichkeit:\n* Position: {{position}}\n* Unternehmen: {{company}}\n* URL: {{url}}",
    "title": "Remote Work App - {{position}} @{{company}}",
    "subject": "Job geteilt von Remote Work App",
    "dialogTitle": "Einen Remote-Job teilen"
  },
  "datepicker": {
    "selectDate": "Datum auswählen",
    "year": "Jahr",
    "month": "Monat",
    "previousMonth": "Vorheriger Monat",
    "nextMonth": "Nächster Monat",
    "weekdays": [
      "So",
      "Mo",
      "Di",
      "Mi",
      "Do",
      "Fr",
      "Sa"
    ],
    "months": [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ]
  },
  "tabs": {
    "allJobs": "Alle Jobs",
    "favorites": "Favoriten",
    "resumeBuilder": "Lebenslauf",
    "applications": "Bewerbungen",
    "profile": "Profil"
  },
  "favorites": {
    "deleteAll": "Alle Favoriten löschen",
    "empty": "Noch keine Favoriten. Tippe auf das Herz eines Jobs, um ihn hier zu speichern."
  },
  "icons": {
    "jobActions": "Job-Aktionen",
    "addToFavorites": "Zu Favoriten hinzufügen",
    "removeFromFavorites": "Aus Favoriten entfernen",
    "share": "Teilen",
    "openUrl": "URL öffnen",
    "markApplied": "Als beworben markieren",
    "removeApplied": "Bewerbung entfernen"
  },
  "job": {
    "applied": "Beworben",
    "fit": "Match {{score}}%"
  },
  "list": {
    "found": "gefunden"
  },
  "onboarding": {
    "tagline": "Entdecke kuratierte Remote-Möglichkeiten aus aller Welt!",
    "next": "Weiter"
  },
  "tour": {
    "skip": "Überspringen",
    "next": "Weiter",
    "getStarted": "Loslegen",
    "slides": {
      "welcome": {
        "title": "Willkommen",
        "description": "Eine kurze Tour durch die Hauptfunktionen, damit du schneller deinen nächsten Remote-Job findest."
      },
      "search": {
        "title": "Jobs suchen und filtern",
        "description": "Suche per Stichwort und verfeinere Ergebnisse nach Datum, Tags oder Bewerbungsstatus."
      },
      "favorites": {
        "title": "Favoriten und Bewerbungen",
        "description": "Tippe das Herz an, um Jobs zu speichern, und markiere die, auf die du dich beworben hast."
      },
      "tracker": {
        "title": "Bewerbungen verfolgen",
        "description": "Markiere Jobs als beworben und verfolge jeden über Phasen – Interview, Angebot – mit Notizen und Daten."
      },
      "alerts": {
        "title": "Benachrichtigungen bei neuen Treffern",
        "description": "Speichere eine Suche und erhalte eine Push-Benachrichtigung, sobald neue Remote-Jobs zu deinen Stichwörtern passen."
      },
      "resume": {
        "title": "Erstelle deinen Lebenslauf",
        "description": "Erstelle einen professionellen Lebenslauf, exportiere ihn als PDF oder DOCX und sieh, wie gut jeder Job zu deinen Fähigkeiten passt."
      },
      "account": {
        "title": "Anmelden zum Synchronisieren",
        "description": "Erstelle ein kostenloses Konto, um Lebensläufe, Bewerbungen, Favoriten und Alerts auf allen Geräten zu sichern."
      },
      "settings": {
        "title": "Designs und Sprachen",
        "description": "Wechsle zwischen hellem und dunklem Modus und wähle aus 9 Sprachen in den Einstellungen."
      }
    }
  },
  "theme": {
    "toggle": "Design wechseln"
  },
  "settings": {
    "title": "Einstellungen",
    "theme": "Design",
    "themeLight": "Hell",
    "themeDark": "Dunkel",
    "language": "Sprache",
    "open": "Einstellungen öffnen",
    "close": "Schließen",
    "developer": "Entwickler",
    "hideAds": "Werbung ausblenden",
    "removeAds": {
      "title": "Werbung entfernen",
      "buy": "Werbung entfernen — {{price}}",
      "restore": "Käufe wiederherstellen",
      "purchased": "Danke, dass du RemoteWork unterstützt! Die Werbung ist deaktiviert.",
      "successTitle": "Werbung entfernt",
      "successMessage": "Danke für deine Unterstützung! Die Werbung ist jetzt überall in der App deaktiviert.",
      "errorTitle": "Kauf fehlgeschlagen",
      "errorMessage": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "restoreEmptyTitle": "Nichts wiederherzustellen",
      "restoreEmptyMessage": "Für dieses Konto wurde kein früherer Kauf gefunden."
    },
    "tour": "Tour",
    "replayTour": "Tour erneut starten",
    "account": "Konto",
    "deleteAccount": {
      "action": "Konto löschen",
      "confirmTitle": "Konto löschen?",
      "confirmMessage": "Dies löscht dein Konto und alle synchronisierten Daten – Lebensläufe, Bewerbungen, Favoriten und Alerts – dauerhaft. Das kann nicht rückgängig gemacht werden.",
      "errorTitle": "Konto konnte nicht gelöscht werden",
      "errorMessage": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "reauthMessage": "Bitte melde dich aus Sicherheitsgründen ab und wieder an und versuche dann erneut, dein Konto zu löschen."
    },
    "about": "Über",
    "privacyPolicy": "Datenschutzerklärung",
    "website": "Website besuchen"
  },
  "ad": {
    "sponsored": "Gesponsert"
  },
  "consent": {
    "message": "Wir verwenden Analyse-Cookies, um zu verstehen, wie die Seite genutzt wird. Sie bleiben deaktiviert, bis du zustimmst.",
    "accept": "Akzeptieren",
    "reject": "Ablehnen"
  },
  "disclaimer": {
    "title": "Über die Stellenanzeigen",
    "message": "Die in dieser App angezeigten Stellen stammen aus Drittquellen und öffentlichen APIs. Wir veröffentlichen, kuratieren oder kontrollieren diese Anzeigen nicht und können weder die Richtigkeit noch die Qualität oder Verfügbarkeit einer Stelle garantieren. Bestätige die Angaben vor einer Bewerbung immer direkt beim Arbeitgeber.",
    "okCountdown": "OK ({{seconds}})"
  },
  "resume": {
    "title": "Lebenslauf-Generator",
    "newResume": "Neu",
    "newResumePrompt": "Lebenslauf benennen",
    "namePlaceholder": "z. B. Lebenslauf Frontend",
    "lastModified": "Zuletzt geändert",
    "discardTitle": "Änderungen verwerfen?",
    "discardMessage": "Du hast nicht gespeicherte Änderungen.",
    "webPlaceholder": {
      "title": "Der Lebenslauf-Generator ist nur in der Mobile-App verfügbar",
      "subtitle": "Öffne die App auf Android oder iOS, um deinen Lebenslauf zu erstellen und zu exportieren."
    },
    "actions": {
      "edit": "Bearbeiten",
      "duplicate": "Duplizieren",
      "delete": "Löschen",
      "more": "Weitere Optionen",
      "deleteConfirmTitle": "Lebenslauf löschen?",
      "deleteConfirmMessage": "\"{{name}}\" dauerhaft löschen? Dies kann nicht rückgängig gemacht werden."
    },
    "empty": {
      "title": "Noch keine Lebensläufe",
      "subtitle": "Erstelle einen professionellen Lebenslauf und exportiere ihn als PDF oder DOCX.",
      "cta": "Ersten Lebenslauf erstellen",
      "skillsHint": "Füge Fähigkeiten wie JavaScript, Design, Führung hinzu…"
    },
    "sections": {
      "personalInfo": "Persönliche Daten",
      "experience": "Erfahrung",
      "education": "Ausbildung",
      "skills": "Fähigkeiten",
      "languages": "Sprachen",
      "links": "Links",
      "template": "Vorlage",
      "contact": "Kontakt",
      "summary": "Zusammenfassung",
      "personalization": "Personalisierung",
      "preview": "Vorschau"
    },
    "fields": {
      "fullName": "Vollständiger Name",
      "title": "Berufsbezeichnung",
      "email": "E-Mail",
      "phone": "Telefon",
      "location": "Ort",
      "website": "Webseite",
      "summary": "Berufliche Zusammenfassung",
      "company": "Unternehmen",
      "position": "Position",
      "institution": "Einrichtung",
      "degree": "Abschluss",
      "field": "Fachgebiet",
      "startDate": "Beginn",
      "endDate": "Ende",
      "current": "Ich arbeite derzeit hier",
      "present": "Heute",
      "description": "Beschreibung",
      "skillPlaceholder": "Fähigkeit hinzufügen",
      "languageName": "Sprache",
      "languageProficiency": "Niveau",
      "linkLabel": "Bezeichnung",
      "linkUrl": "URL",
      "phoneCountryCode": "Ländercode"
    },
    "proficiency": {
      "basic": "Grundkenntnisse",
      "conversational": "Konversationssicher",
      "fluent": "Fließend",
      "native": "Muttersprache"
    },
    "templates": {
      "modern": "Modern",
      "classic": "Klassisch",
      "minimal": "Minimal",
      "modernDescription": "Zweispaltiges Layout mit farbiger Seitenleiste.",
      "classicDescription": "Traditionell in Schwarz-Weiß, einspaltig.",
      "minimalDescription": "Klar, viel Weißraum, ohne Farbe."
    },
    "buttons": {
      "addExperience": "Erfahrung hinzufügen",
      "addEducation": "Ausbildung hinzufügen",
      "addLanguage": "Sprache hinzufügen",
      "addLink": "Link hinzufügen",
      "remove": "Entfernen",
      "save": "Speichern",
      "discard": "Verwerfen",
      "export": "Exportieren",
      "exportPdf": "Als PDF exportieren",
      "exportDocx": "Als DOCX exportieren",
      "create": "Erstellen",
      "previous": "Zurück",
      "next": "Weiter"
    },
    "export": {
      "preparing": "Datei wird vorbereitet…",
      "preparingHint": "Wähle ein Format. Die Datei wird im Teilen-Menü angezeigt.",
      "errorTitle": "Export fehlgeschlagen",
      "errorMessage": "Beim Exportieren deines Lebenslaufs ist ein Fehler aufgetreten."
    },
    "validation": {
      "invalidEmail": "Bitte gib eine gültige E-Mail-Adresse ein.",
      "invalidCountryCode": "Bis zu 4 Ziffern, optional mit + am Anfang.",
      "invalidWebsite": "Bitte gib eine gültige Webseite ein (z. B. beispiel.de)."
    },
    "personalization": {
      "title": "Personalisieren",
      "colorMode": "Farbschema",
      "modes": {
        "light": "Hell",
        "dark": "Dunkel"
      },
      "fontFamily": "Schrift",
      "fonts": {
        "sans": "Sans",
        "serif": "Serif",
        "modern": "Modern",
        "mono": "Mono"
      },
      "fontSize": "Schriftgröße",
      "sizes": {
        "title": "Titel",
        "subtitle": "Untertitel",
        "body": "Text"
      },
      "increase": "{{field}} vergrößern",
      "decrease": "{{field}} verkleinern"
    },
    "photo": {
      "placeholder": "Kein Foto",
      "choose": "Foto hinzufügen",
      "change": "Foto ändern",
      "remove": "Entfernen",
      "permissionTitle": "Berechtigung erforderlich",
      "permissionMessage": "Erlaube den Zugriff auf die Galerie, um ein Profilfoto auszuwählen."
    }
  },
  "sort": {
    "recent": "Neueste",
    "bestFit": "Beste Übereinstimmung",
    "toggle": "Nach Übereinstimmung sortieren"
  },
  "applyKit": {
    "title": "Bewerbungs-Kit",
    "hint": "Zum Kopieren tippen und ins Formular einfügen.",
    "copied": "Kopiert",
    "openExternal": "Im Browser öffnen"
  },
  "applications": {
    "title": "Bewerbungen",
    "empty": {
      "title": "Noch keine Bewerbungen",
      "subtitle": "Jobs, auf die du dich bewirbst, erscheinen hier, um den Status zu verfolgen."
    },
    "status": {
      "applied": "Beworben",
      "interviewing": "Gespräch",
      "offer": "Angebot",
      "rejected": "Abgelehnt"
    },
    "notesPlaceholder": "Notizen hinzufügen…",
    "remove": "Entfernen",
    "removeConfirm": "Diese Bewerbung entfernen?",
    "lastUpdate": "Zuletzt aktualisiert: {{date}}",
    "editDate": "Datum bearbeiten",
    "addManual": "Bewerbung hinzufügen"
  },
  "auth": {
    "account": "Konto",
    "signIn": "Anmelden",
    "signUp": "Konto erstellen",
    "signOut": "Abmelden",
    "title": {
      "signIn": "Willkommen zurück",
      "signUp": "Konto erstellen"
    },
    "email": "E-Mail",
    "password": "Passwort",
    "showPassword": "Passwort anzeigen",
    "hidePassword": "Passwort verbergen",
    "forgotPassword": "Passwort vergessen?",
    "resetSent": "E-Mail zum Zurücksetzen gesendet — prüfe dein Postfach.",
    "enterEmailFirst": "Gib zuerst deine E-Mail ein.",
    "noAccount": "Kein Konto? Erstelle eins",
    "haveAccount": "Schon ein Konto? Anmelden",
    "criteria": {
      "minLength": "Mindestens 8 Zeichen",
      "uppercase": "Ein Großbuchstabe",
      "lowercase": "Ein Kleinbuchstabe",
      "numeric": "Eine Zahl",
      "special": "Ein Sonderzeichen"
    },
    "errors": {
      "invalid-email": "Diese E-Mail sieht ungültig aus.",
      "invalid-credential": "E-Mail oder Passwort ist falsch.",
      "user-not-found": "Kein Konto mit dieser E-Mail gefunden.",
      "wrong-password": "E-Mail oder Passwort ist falsch.",
      "email-already-in-use": "Ein Konto mit dieser E-Mail existiert bereits.",
      "weak-password": "Das Passwort erfüllt die Anforderungen nicht.",
      "requires-recent-login": "Bitte melde dich erneut an.",
      "too-many-requests": "Zu viele Versuche. Später erneut versuchen.",
      "network": "Netzwerkfehler. Prüfe deine Verbindung.",
      "not-configured": "Anmeldung derzeit nicht verfügbar.",
      "unknown": "Etwas ist schiefgelaufen. Bitte erneut versuchen."
    },
    "continueGoogle": "Mit Google fortfahren",
    "continueApple": "Mit Apple fortfahren",
    "or": "oder",
    "loggedInAnonymous": "Anonym angemeldet",
    "continueAnonymous": "Anonym fortfahren",
    "loggedOutWarning": "Nicht angemeldet — deine Daten liegen nur auf diesem Gerät und könnten verloren gehen."
  },
  "profile": {
    "title": "Profil",
    "signInRegister": "Anmelden / Registrieren",
    "more": "Mehr"
  },
  "applyBrowser": {
    "title": "Bewerben"
  }
}
